export default "__VITE_ASSET__d7908108__"